import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import parse from "html-react-parser";
import { Box, Typography } from "@mui/material";
import CustomSlider from "../../Components/CustomSlider";

import newsImg1 from "../../assets/b3.jpg";
import newsImg3 from "../../assets/b1.jpg";
import news4pic1 from "../../assets/news4-pic1.png";
import news4pic2 from "../../assets/news4-pic2.jpg";
import news4pic3 from "../../assets/news4-pic3.png";
import news4pic4 from "../../assets/news4-pic4.png";
import news4pic5 from "../../assets/news4-pic5.jpg";
import news4pic6 from "../../assets/news4-pic6.jpg";
import news4pic7 from "../../assets/news4-pic7.jpg";

import news5pic1 from "../../assets/news5-pic1.png";
import news5pic2 from "../../assets/news5-pic2.png";
import news5pic3 from "../../assets/news5-pic3.png";
import news5pic4 from "../../assets/news5-pic4.png";
import news5pic5 from "../../assets/news5-pic5.png";
import news5pic6 from "../../assets/news5-pic6.png";
import news5pic7 from "../../assets/news5-pic7.jpeg";

import news6pic1 from "../../assets/news6-pic1.png";
import news6pic2 from "../../assets/news6-pic2.jpg";

import news7pic1 from "../../assets/news7-pic1.jpeg";
import news7pic2 from "../../assets/news7-pic2.jpeg";
import news7pic3 from "../../assets/news7-pic3.jpeg";
import news7pic4 from "../../assets/news7-pic4.jpeg";
import news7pic5 from "../../assets/news7-pic5.jpeg";
import news7pic6 from "../../assets/news7-pic6.jpeg";
import news7pic7 from "../../assets/news7-pic7.jpeg";
import news7pic8 from "../../assets/news7-pic8.jpeg";
import news7pic9 from "../../assets/news7-pic9.jpeg";
import news7pic10 from "../../assets/news7-pic10.jpeg";
import news7pic11 from "../../assets/news7-pic11.jpeg";
import news7pic12 from "../../assets/news7-pic12.jpeg";
import news7pic13 from "../../assets/news7-pic13.jpeg";
import ImageSlider from "../../Components/CustomSlider";

//2025
import news8pic1 from "../../assets/poziv15januar.jpg";
import news9pic1 from "../../assets/9img.jpg";
import news10pic1 from "../../assets/pic10.jpg";
import news11pic1 from "../../assets/no11pic1.jpg";
import news12pic1 from "../../assets/no12pic1.jpg";
import hawkingsLogoBig from "../../assets/hawking_logo_big.jpg";
import news16pic1 from "../../assets/news16pic1.jpg";
import news17pic1 from "../../assets/news17pic1.jpg";
import news18pic1 from "../../assets/news18pic1.jpg";
import news19pic1 from "../../assets/news19pic1.jpg";
import news20pic1 from "../../assets/news20pic1.jpg";
import news21pic1 from "../../assets/news21pic1.jpg";
import news22pic1 from "../../assets/news22pic1.jpg";
import news23pic1 from "../../assets/news23pic1.jpg";
import news24pic1 from "../../assets/news24pic1.jpg";
import news25pic1 from "../../assets/news25pic1.jpg";
import news26pic1 from "../../assets/news26pic1.jpg";
import news27pic1 from "../../assets/news27pic1.jpg";
import news28pic1 from "../../assets/news28pic1.jpg";
import news29pic1 from "../../assets/news29pic1.jpg";

const news4pic1ImgTag = `<img src=${news4pic1} style="max-width: 50%;"/>`;
const news4pic2ImgTag = `<img src=${news4pic2} style="max-width: 50%;"/>`;
const news4pic3ImgTag = `<img src=${news4pic3} style="max-width: 49%;"/>`;
const news4pic4ImgTag = `<img src=${news4pic4} style="max-width: 49%;"/>`;
const news4pic5ImgTag = `<img src=${news4pic5} style="max-width: 49%;"/>`;
const news4pic6ImgTag = `<img src=${news4pic6} style="max-width: 49%;"/>`;
const news4pic7ImgTag = `<img src=${news4pic7} style="max-width: 49%; margin-top:25px;"/>`;

const imagesNews5 = [
  news5pic1,
  news5pic2,
  news5pic3,
  news5pic7,
  news5pic4,
  news5pic5,
  news5pic6,
];

const imagesNews6 = [news6pic1, news6pic2];
const imagesNews7 = [
  news7pic1,
  news7pic2,
  news7pic3,
  news7pic4,
  news7pic5,
  news7pic6,
  news7pic7,
  news7pic8,
  news7pic9,
  news7pic10,
  news7pic11,
  news7pic12,
  news7pic13,
];

const NewsDetails = () => {
  const params = useParams();
  const [newsDetails, setNewsDetails] = useState();
  const { t } = useTranslation();

  const news = [
    {
      id: 1,
      date: "10.06.2024",
      title: "HAWKING",
      content: t("news.no1"),
      image: newsImg1,
      href: "https://www.ucg.ac.me/objava/blog/618282/objava/181449-span-class-cyrlatignore-hawking-span-projekat-predstavljen-na-sajmu-evropskih-projekata",
      fullContent: t("news.news_fullContent.no1"),
    },
    {
      id: 25,
      date: "04.06.2024",
      content: t("news.no25"),
      image: news25pic1,
      fullContent: t("news.news_fullContent.no25"),
    },
    {
      id: 2,
      date: "29.05.2024",
      title: "HAWKING",
      content: t("news.no2"),
      href: "https://www.ucg.ac.me/objava/blog/618282/objava/180943-onlajn-sastanak-projekta-hawking-virtuelna-saradnja-i-osiguranje-kvaliteta",
      fullContent: t("news.news_fullContent.no2"),
    },
    {
      id: 3,
      date: "29.02.2024",
      title: "HAWKING",
      content: t("news.no3"),
      image: newsImg3,
      href: "https://www.ucg.ac.me/objava/blog/618282/objava/180340-kick-off-za-projekat-hawking-poboljsanje-pristupa-visokom-obrazovanju-za-osobe-s-invaliditetom",
      fullContent: t("news.news_fullContent.no3"),
    },
    {
      id: 4,
      date: "10.10.2024",
      title: "HAWKING",
      content: t("news.no4"),
      href: "https://www.ucg.ac.me/objava/blog/618282/objava/180340-kick-off-za-projekat-hawking-poboljsanje-pristupa-visokom-obrazovanju-za-osobe-s-invaliditetom",
      fullContent: t("news.news_fullContent.no4")
        .replace("IMG1", news4pic1ImgTag)
        .replace("IMG2", news4pic2ImgTag)
        .replace("IMG3", news4pic3ImgTag)
        .replace("IMG4", news4pic4ImgTag)
        .replace("IMG5", news4pic5ImgTag)
        .replace("IMG6", news4pic6ImgTag)
        .replace("IMG7", news4pic7ImgTag),
    },
    {
      id: 5,
      date: "29.10.2024",
      title: "HAWKING",
      content: t("news.no5"),
      // image: newsImg3,
      // href: "https://www.ucg.ac.me/objava/blog/618282/objava/180340-kick-off-za-projekat-hawking-poboljsanje-pristupa-visokom-obrazovanju-za-osobe-s-invaliditetom",
      fullContent: t("news.news_fullContent.no5"),
    },
    {
      id: 6,
      date: "08.11.2024",
      title: "HAWKING",
      content: t("news.no6"),
      // image: newsImg3,
      // href: "https://www.ucg.ac.me/objava/blog/618282/objava/180340-kick-off-za-projekat-hawking-poboljsanje-pristupa-visokom-obrazovanju-za-osobe-s-invaliditetom",
      fullContent: t("news.news_fullContent.no6"),
    },
    {
      id: 7,
      date: "26.11.2024",
      title: "HAWKING",
      content: t("news.no7"),
      fullContent: t("news.news_fullContent.no7"),
    },
    {
      id: 8,
      date: "30.12.2024",
      content: t("news.no8"),
      image: news8pic1,
      fullContent: t("news.news_fullContent.no8"),
    },
    {
      id: 9,
      date: "03.02.2025",
      content: t("news.no9"),
      image: news9pic1,
      fullContent: t("news.news_fullContent.no9"),
    },
    {
      id: 10,
      date: "26.01.2025",
      content: t("news.no10"),
      image: news10pic1,
      fullContent: t("news.news_fullContent.no10"),
    },
    {
      id: 11,
      date: "26.02.2025",
      content: t("news.no11"),
      image: news11pic1,
      fullContent: t("news.news_fullContent.no11"),
    },
    {
      id: 12,
      date: "13.03.2025",
      content: t("news.no12"),
      image: news12pic1,
      fullContent: t("news.news_fullContent.no12"),
    },
    {
      id: 13,
      date: "24.04.2025",
      content: t("news.no13"),
      image: hawkingsLogoBig,
      fullContent: t("news.news_fullContent.no13"),
    },
    {
      id: 14,
      date: "30.04.2025",
      content: t("news.no14"),
      image: hawkingsLogoBig,
      fullContent: t("news.news_fullContent.no14"),
    },
    {
      id: 26,
      date: "30.04.2025",
      content: t("news.no26"),
      image: hawkingsLogoBig,
      fullContent: t("news.news_fullContent.no26"),
    },
    {
      id: 29,
      date: "28.05.2025",
      content: t("news.no29"),
      image: news29pic1,
      fullContent: t("news.news_fullContent.no29"),
    },
    {
      id: 27,
      date: "10.11.2025",
      content: t("news.no27"),
      image: news27pic1,
      fullContent: t("news.news_fullContent.no27"),
    },
    {
      id: 15,
      date: "17.11.2025",
      content: t("news.no15"),
      image: hawkingsLogoBig,
      fullContent: t("news.news_fullContent.no15"),
    },
    {
      id: 16,
      date: "19.11.2025",
      content: t("news.no16"),
      image: news16pic1,
      fullContent: t("news.news_fullContent.no16"),
    },
    {
      id: 23,
      date: "06.03.2026",
      content: t("news.no23"),
      image: news23pic1,
      fullContent: t("news.news_fullContent.no23"),
    },
    {
      id: 18,
      date: "15.04.2026",
      image: news18pic1,
      fullContent: t("news.news_fullContent.no18"),
    },
    {
      id: 24,
      date: "23.04.2026",
      image: news24pic1,
      fullContent: t("news.news_fullContent.no24"),
    },
    {
      id: 17,
      date: "11.05.2026",
      content: t("news.no17"),
      image: news17pic1,
      fullContent: t("news.news_fullContent.no17"),
    },
    {
      id: 20,
      date: "12.05.2026",
      content: t("news.no20"),
      image: news20pic1,
      fullContent: t("news.news_fullContent.no20"),
    },
     {
      id: 21,
      date: "13.05.2026",
      content: t("news.no21"),
      image: news20pic1,
      fullContent: t("news.news_fullContent.no21"),
    },
    {
      id: 28,
      date: "18.05.2026",
      content: t("news.no28"),
      image: news28pic1,
      fullContent: t("news.news_fullContent.no28"),
    },
    {
      id: 19,
      date: "10.06.2026",
      content: t("news.no19"),
      image: news19pic1,
      fullContent: t("news.news_fullContent.no19"),
    },
    {
      id: 22,
      date: "22.06.2026",
      content: t("news.no22"),
      image: news22pic1,
      fullContent: t("news.news_fullContent.no22"),
    }
  ];

  useEffect(() => {
    if (params.id) {
      setNewsDetails(news.find((item) => item.id === parseInt(params.id)));
    }
  }, [params.id, t]);

  return (
    <Box sx={{ paddingY: 6, paddingX: 30 }}>
      {newsDetails && (
        <>
          <Box sx={{ paddingBottom: 3 }}>
            <Typography
              className="date"
              sx={{ fontSize: "14.4px", color: "#999" }}
            >
              {newsDetails?.date}
            </Typography>
            <Typography
              className="title"
              sx={{
                fontSize: "28px",
                color: "#444",
                fontWeight: "600",
                paddingBottom: 1.5,
              }}
            >
              {newsDetails?.content}
            </Typography>
            <hr
              style={{
                height: "2px",
                borderWidth: 0,
                color: "#452773",
                backgroundColor: "#452773",
              }}
            />
          </Box>
          {newsDetails?.image && (
            <Box>
              <img
                src={newsDetails?.image}
                style={{ height: "510px" }}
                alt={"hawking"}
              />
            </Box>
          )}
          <Box className="full_content">{parse(newsDetails?.fullContent)}</Box>
          {newsDetails?.id == 5 && <ImageSlider images={imagesNews5} />}
          {newsDetails?.id == 6 && <ImageSlider images={imagesNews6} />}
          {newsDetails?.id == 7 && <ImageSlider images={imagesNews7} />}
        </>
      )}
      <style>
        {`.full_content p, ul, ol, span {
          text-align: justify;
          line-height: 1.8;
          color: #555;
        }
        p {
          margin-bottom: 30px
        }
        `}
      </style>
    </Box>
  );
};

export default NewsDetails;
